import {
    post
} from './request'

/** 获得分页列表 */
export const getCategoryList = data => post('/index/gm_cate_list', data)
export const gm_article_list = data => post('/index/gm_article_list', data)
//
export const getPage = data => post('/index/gm_cate_article_list', data)
// 政务公开详情页
export const getOne = data => post('/index/gm_article_detail', data)